import React, {useCallback, useContext, useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {useHttp} from '../hooks/http.hook'
import config from '../config.json'
import {ModalWin} from "../elements/ModalWin"
import {LoaderClass} from "../elements/LoaderClass"
import {LinksClass} from "../components/LinksClass"
import {
    getIcon,
    getItems,
    objectLang,
    removeCookieOfFolderId,
    setErrorWindow,
    setImagesDataToSlider,
    setLocalStorageItem,
    setPathBack
} from "../functions"
import {AuthContext} from "../context/AuthContext"
import {PathLineClass} from "../elements/PathLineClass"

export const FolderSharePage = () => {
    setLocalStorageItem('page', 'FolderSharePage')
    const auth = useContext(AuthContext)
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const [documents, setDocuments] = useState({})
    const [items, setItems] = useState([])
    const [countItems, setCountItems] = useState(0)
    const {request, loading} = useHttp()
    const navigate = useNavigate()
    const code = useParams().code

    const getData = useCallback(async () => {
        const l = objectLang().language.lang
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/folder/open-share/${code}`, 'GET')

            if (data.status > 200) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code, '', '', '', '', 'replaceToMain'))
                return
            }

            const res = {
                name: data.name,
                parent: data.parentFID,
                folders: data.folders,
                links: data.links,
                notes: data.notes,
                path: data.path,
                upLevel: data.upLevel,
                opening: 'open-public',
                owner: data.owner,
                sort: data.sort,
                order: data.order,
            }

            setDocuments(res)
            setItems(getItems(res))
            setCountItems(res.folders.length + res.links.length + res.notes.length)
            setPathBack(`/${l}/folder/open-share/${code}`)
            removeCookieOfFolderId(res.parent)
        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }, [code, request])

    useEffect(() => {
        getData().then()
    }, [getData])

    useEffect(() => {
        if (!items.length) return

        const enriched = items.map(item => {
            if (item.type === 'link') {
                return {
                    ...item,
                    from: item.from || '',
                    thumbUrl: item.thumbUrl || ''
                }
            }
            return item
        })

        setImagesDataToSlider(enriched)
    }, [items])

    if (loading) {
        return (
            <>
                <PathLineClass documents={documents}/>
                <LoaderClass/>
            </>
        )
    }

    if (!allowed) {
        return (
            <>
                <ModalWin data={dataModal}/>
            </>
        )
    }

    if (Object.keys(documents).length > 0) {

        for (const item of items) {
            if (item.type === 'link') {
                if (!item.thumbUrl) {
                    const iconDefault = require('../images/link-logo-default.png')
                    item.thumbUrl = getIcon(item.from, iconDefault) || iconDefault
                }
            }
        }

        return (
            <>
                <PathLineClass documents={documents}/>
                <LinksClass
                    auth={auth}
                    documents={documents}
                    items={items}
                    rootFolder={undefined}
                    setCountItems={setCountItems}
                    countItems={countItems}
                    navigate={navigate}
                />
            </>
        )
    }
}
